import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';

// Some of these products types don't currently appear in LIHP collections,
// but are included here for future-proofing.
const entityTypeToProductIdType: Record<string, string> = {
  COURSE: 'course',
  'GUIDED PROJECT': 'course',
  PROJECT: 'course',
  SPECIALIZATION: 's12n',
  'PROFESSIONAL CERTIFICATE': 's12n',
  DEGREE: 'degree',
  'POSTGRADUATE DIPLOMA': 'degree',
  MASTERTRACK: 'mastertrack',
  'GRADUATE CERTIFICATE': 'certificate',
  'UNIVERSITY CERTIFICATE': 'certificate',
};

export const shouldShowBasedOnCollectionType = (collectionId: string) =>
  !(
    collectionId === 'mastertrack' ||
    collectionId === 'degree' ||
    collectionId === 'FULLY_PERSONALIZED:recently-viewed-xdps'
  );

export const isPartOfRecsFeedbackExperiment = () =>
  GrowthDiscoveryExperiments.get('showRecsFeedbackOnProductCards') === true;

export const entityIdToFullProductId = (entityId?: string) => {
  if (entityId) {
    const [entityType, shortProductId] = entityId.split('~');
    return `${entityTypeToProductIdType[entityType]}~${shortProductId}`;
  }
  return '';
};
